import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CommonCommunicationService {
  constructor() {}

  moduleList$: BehaviorSubject<any> = new BehaviorSubject(null);
  userLoginData$: BehaviorSubject<any> = new BehaviorSubject(null);
  activeShopId$: BehaviorSubject<any> = new BehaviorSubject(null);
  registerData$: BehaviorSubject<any> = new BehaviorSubject(null);
  notificationBarState$: BehaviorSubject<any> = new BehaviorSubject(null);
  userBarState$: BehaviorSubject<any> = new BehaviorSubject(null);
  authToken: any;
  refreshToken: string | null = null;
  shippingToken: string | null = null;
  userData: any;
  shopDetails$: BehaviorSubject<any> = new BehaviorSubject(null);
  shopUserData$: BehaviorSubject<any> = new BehaviorSubject(null);
  loginFlow$: BehaviorSubject<any> = new BehaviorSubject(false);
  rolePermission$: BehaviorSubject<any> = new BehaviorSubject(null);
  isSuperAdmin$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  cartData$: BehaviorSubject<any> = new BehaviorSubject(null);
  loader$: BehaviorSubject<any> = new BehaviorSubject(false);
  public isSidebarCollapsed$ = new BehaviorSubject<boolean>(false);
  public intialSetupData = new BehaviorSubject<any>({});
  public isSetupComplete = new BehaviorSubject<any>(false);

  getSidebarState(): Observable<boolean> {
    return this.isSidebarCollapsed$.asObservable();
  }

  toggleSidebar() {
    this.isSidebarCollapsed$.next(!this.isSidebarCollapsed$.value);
  }

  setSidebarState(state: boolean) {
    this.isSidebarCollapsed$.next(state);
  }

  setRolePermission(acc: any) {
    this.rolePermission$.next(acc);
  }

  getRolePermission(): Observable<any> {
    return this.rolePermission$.asObservable();
  }

  setIsSuperAdmin(value: boolean) {
    this.isSuperAdmin$.next(value);
  }

  getIsSuperAdmin(): Observable<boolean> {
    return this.isSuperAdmin$.asObservable();
  }

  setModuleList(acc: boolean) {
    this.moduleList$.next(acc);
  }

  setAuthToken(acc: any) {
    this.authToken = acc;
  }

  getAuthToken() {
    return this.authToken;
  }

  // Refresh token (rotating) — persisted so it survives a page reload, like 'token'.
  setRefreshToken(token: string | null) {
    this.refreshToken = token;
    if (token) {
      localStorage.setItem('refreshToken', token);
    } else {
      localStorage.removeItem('refreshToken');
    }
  }

  getRefreshToken(): string | null {
    return this.refreshToken || localStorage.getItem('refreshToken');
  }

  // Clear access + refresh tokens (used on a failed refresh / logout).
  clearAuth() {
    this.authToken = null;
    this.refreshToken = null;
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }

  setShippingToken(token: string | null) {
    this.shippingToken = token;
  }

  getShippingToken(): string | null {
    return this.shippingToken;
  }

  getModuleList(): Observable<boolean> {
    return this.moduleList$.asObservable();
  }

  getUserData(): Observable<any> {
    return this.userLoginData$.asObservable();
  }

  setUserData(data: any) {
    this.userData = data;
    this.userLoginData$.next(data);
  }

  getRegisterData(): Observable<any> {
    return this.registerData$.asObservable();
  }

  setRegisterData(data: any) {
    this.registerData$.next(data);
  }
  getActiveShopId(): Observable<any> {
    return this.activeShopId$.asObservable();
  }

  setActiveShopId(data: any) {
    this.activeShopId$.next(data);
  }

  getNotificationBarState(): Observable<any> {
    return this.notificationBarState$.asObservable();
  }

  setNotificationBarState(data: any) {
    this.notificationBarState$.next(data);
  }

  getUserBarState(): Observable<any> {
    return this.userBarState$.asObservable();
  }

  setUserBarState(data: any) {
    this.userBarState$.next(data);
  }

  getShopUserData(): Observable<any> {
    return this.shopUserData$.asObservable();
  }

  setShopUserData(data: any) {
    this.shopUserData$.next(data);
  }

  getLoginFlow(): Observable<any> {
    return this.loginFlow$.asObservable();
  }

  setLoginFlow(data: any) {
    this.loginFlow$.next(data);
  }

  getShopDetails(): Observable<any> {
    return this.shopDetails$.asObservable();
  }

  setShopDetails(data: any) {
    this.shopDetails$.next(data);
  }
  setCartData(acc: any) {
    this.cartData$.next(acc);
  }

  getCartData() {
    return this.cartData$;
  }

  setLoader(acc: any) {
    this.loader$.next(acc);
  }

  getLoader() {
    return this.loader$;
  }
}
